import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import Button from '../utility/Button';
import CustomInput from '../utility/CustomInput';
import CustomCheckbox from '../utility/CustomCheckbox';
import CustomTextArea from '../utility/CustomTextArea';
import PropTypes from 'prop-types';
import Dropdown from '../utility/Dropdown';
import SelectButton from '../utility/SelectButton';
import Notification from '../utility/Notification';
import LoadingSpinner from '../utility/LoadingSpinner';
import { withTranslation } from 'react-i18next';
import { tShirtSizes as sizes, difficultyName } from '../../constants';
import TagManager from 'react-gtm-module';

import {
  validateEmail,
  validateEmailNotRequired,
  validateEnglishOnly,
  validateChecked,
  validateIC,
  validateMobileNo,
  validateRequired,
  validateTshirtName,
  validateHealth,
  validateHealthCheckbox
} from '../../js/validators';
import {
  setBookingFormData,
  setBookingPrimaryDriver,
  setBookingStep,
  fetchPricingInfo,
  postSaveForLater
} from '../../actions/booking';

import { NOTIFICATION_DURATION as notificationDuration } from '../../constants';

class BookingDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetError: false,
      showNotification: false,
      showPopupSize: false,
    };
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleChangeDriver = this.handleChangeDriver.bind(this);
    this.saveForLater = this.saveForLater.bind(this);
    this.doShowNotification = this.doShowNotification.bind(this);
    this.togglePopUpSize = this.togglePopUpSize.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleFieldBlur(e, values, blurHandler) {
    const { setBookingFormData } = this.props;
    this.setState({
      resetError: false
    });
    blurHandler(e);
    setBookingFormData(values);
  }

  // Save redux state when dropdown changes
  handleFieldChange(e, values, fieldName, changeHandler) {
    const { setBookingFormData } = this.props;
    changeHandler(e);
    setBookingFormData({
      ...values,
      [fieldName]: e.target.value
    });
  }

  handleChangeDriver(bool) {
    // if (this.canChangeDriver) {
    this.props.setBookingPrimaryDriver(bool);
    this.setState({
      resetError: true
    });
    // }
  }

  saveForLater() {
    this.props.handleSaveForLater(2).then(() => {
      if (!this.state.showNotification && this._isMounted) {
        this.doShowNotification();
      }
    });
  }

  doShowNotification() {
    window.scrollTo(0, 0);
    this.setState(
      {
        showNotification: true
      },
      () => {
        setTimeout(() => {
          if (this._isMounted) {
            this.setState({
              showNotification: false
            });
          }
        }, notificationDuration);
      }
    );
  }

  togglePopUpSize(val){
    this.setState({showPopupSize: val});
  }

  get isByAge() {
    return Object.prototype.hasOwnProperty.call(this.props.bookingPax, 'adult');
  }

  get canChangeDriver() {
    return (
      (this.isByAge ? this.props.bookingPax.adult : this.props.bookingPax) > 1
    );
  }

  render() {
    const {
      bookingPax,
      bookingFormData,
      isByPax,
      bookingDate,
      primaryDriver,
      setBookingFormData,
      setBookingStep,
      fetchPricingInfo,
      hide,
      slug,
      signedIn,
      loading,
      t,
      saveMessage,
      byorIsMember,
      promoCode,
      tourDate,
      byorSelected
    } = this.props;

    const { resetError, showNotification } = this.state;
    const isRaptorEvent = slug === "a-desaru-fruit-farm-resort-staycation" || slug === "raptor-rev";
    var participants = 0;
    if (typeof bookingPax === 'object') {
      participants = bookingPax.adult + bookingPax.child;
    } else {
      participants = bookingPax;
    }
    participants = participants > 0 ? participants - 1 : participants;

    return (
      <div className={`col-lg-8 ${hide ? 'fe-hide' : ''}`}>

        {/* Size Chart Popup */}
        <div
          className={`fe-overlay size-popup ${(this.state.showPopupSize) ? ' show' : ''}`}
          onClick={() => this.togglePopUpSize(false)}
        />
        <div
          className={`fe-size-popup-container ${(this.state.showPopupSize) ? ' show' : ''}`}
          tabIndex='0'
        >
          <div className="fe-size-chart-responsive">
            <img
              src='https://shop.sdacford.com.my/images/size_chart.jpg'
            />
          </div>
        </div>

        <Notification show={showNotification}>{saveMessage}</Notification>
        {loading ? <LoadingSpinner /> : null}
        <Formik
          validateOnChange={true}
          validateOnBlur={true}
          initialValues={{
            ...bookingFormData,
            agreeLicense: true,
            agreeTnc: false
          }}
          onSubmit={values => {
            setBookingFormData(values);
            setBookingStep(3);
            fetchPricingInfo(
              slug,
              bookingPax,
              promoCode,
              null,
              isByPax,
              byorIsMember,
              bookingDate
            );
          }}
        >
          {({ errors, values, handleBlur, handleChange, handleSubmit }) => (
            <form
              noValidate
              onSubmit={handleSubmit}
              className={`fe-form more-margin ${loading ? 'fe-hide' : ''}`}
            >
              <section className='fe-form-details'>
                <fieldset>
                  <legend className='fe-form-title'>
                    {t('form:personalDetails')}
                  </legend>
                  <div className='fe-form-toggle'>
                    <span
                      className={`fe-form-toggle-btn ${
                        primaryDriver ? 'active' : ''
                      }`}
                      onClick={() => this.handleChangeDriver(true)}
                    >
                      {t('form:iAmDriving')}
                    </span>
                    {/* <span
                      className={`fe-form-toggle-btn ${
                        !primaryDriver ? 'active' : ''
                      } ${this.canChangeDriver ? '' : 'disabled'}`}
                      onClick={() => this.handleChangeDriver(false)}
                    > */}
                    <span
                      className={`fe-form-toggle-btn ${
                        !primaryDriver ? 'active' : ''
                      }`}
                      onClick={() => this.handleChangeDriver(false)}
                    >
                      {t('form:elseDriving')}
                    </span>
                  </div>
                  <div className='fe-form-inner'>
                    <div className={'fe-form-field full'}>
                      <label htmlFor='name'>{t('form:fullNameAsIC')}</label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='name'
                        validate={validateEnglishOnly}
                        component={CustomInput}
                      />
                    </div>
                    
                    <div className='fe-form-field'>
                      <label htmlFor='ic'>{t('form:icNo')}</label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='ic'
                        validate={e => validateIC(e, values, primaryDriver)}
                        component={CustomInput}
                      />
                    </div>
                    <div className='fe-form-field'>
                      <label htmlFor='email'>{t('form:email')}</label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='email'
                        name='email'
                        validate={e => validateEmail(e, values, primaryDriver)}
                        component={CustomInput}
                        disabled={signedIn}
                      />
                    </div>
                    <div className='fe-form-field'>
                      <label htmlFor='mobile'>{t('form:mobileNo')}</label>
                      <div className='fe-form-field-mobile'>
                        <div className='fe-form-mob-prefix'>+60</div>
                        <Field
                          onBlur={e =>
                            this.handleFieldBlur(e, values, handleBlur)
                          }
                          type='text'
                          name='mobile'
                          validate={validateMobileNo}
                          component={CustomInput}
                          showError={false}
                          numbersOnly
                        />
                      </div>
                      <span className='fe-form-error'>
                        <ErrorMessage
                          name='mobile'
                          render={msg => t(`error:${msg}`)}
                        />
                      </span>
                    </div>
                    <div className={primaryDriver && isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                      <label htmlFor='driver_experience'>{t('form:offRoadExperience')}</label>
                      <Dropdown
                        name='driver_experience'
                        value={values.driver_experience}
                        customOnChange={false}
                        onChange={e =>
                          this.handleFieldChange(
                            e,
                            values,
                            'driver_experience',
                            handleChange
                          )
                        }
                        options={difficultyName}
                      />
                    </div>
                    <div className={primaryDriver && isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                      <label htmlFor='driver_size'>{t('form:tShirtSize')}</label>
                      <Dropdown
                        name='driver_size'
                        value={values.size}
                        customOnChange={false}
                        onChange={e =>
                          this.handleFieldChange(
                            e,
                            values,
                            'driver_size',
                            handleChange
                          )
                        }
                        options={sizes}
                      />
                      <label className='fe-form-field-description bottom'>
                        <span 
                          className='fe-clickable'
                          onClick={() => this.togglePopUpSize(true)}
                        >{t('form:sizeChart')}</span>
                      </label>
                      <label className='fe-form-field-description bottom'>
                        <span>{t('form:tshirtDescription')}</span>
                      </label>
                    </div>
                    <div className={primaryDriver && isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                      <label htmlFor='driver_tshirtName'>{t('form:tshirtName')}</label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='driver_tshirtName'
                        validate={e => validateTshirtName(e, isRaptorEvent)}
                        component={CustomInput}
                      />
                    </div>
                    <div className={primaryDriver && isRaptorEvent ? 'fe-form-field full' : 'fe-hide'}>
                      <label htmlFor='driver_health'>{t('form:healthDeclaration')}</label>
                      <label className='fe-form-field-description'>
                        <span>{t('form:healthDescription')}</span>
                        <br/><br/>
                        <span>{t('form:healthExample')}</span>
                      </label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='driver_health'
                        validate={e => validateHealth(e, values, 'driver_HealthConfirm', isRaptorEvent)}
                        placeholder={t('form:healthPlaceHolder')}
                        maxLength={0}
                        component={CustomTextArea}
                      />
                    </div>
                    <div className={primaryDriver && isRaptorEvent ? 'fe-form-field full checkbox-description' : 'fe-hide'}>
                      <Field
                        name='driver_HealthConfirm'
                        message={t('form:healthCheckBox')}
                        validate={e => validateHealthCheckbox(e, values, 'driver_health', isRaptorEvent)}
                        component={CustomCheckbox}
                      />
                    </div>
                  </div>
                </fieldset>
                <fieldset className={primaryDriver ? 'fe-hide' : ''}>
                  <legend className='fe-form-title'>
                    {t('form:driverDetails')}
                  </legend>
                  <div className='fe-form-inner'>
                    <div className='fe-form-field full'>
                      <label htmlFor='driver_name'>
                        {t('form:fullNameAsIC')}
                      </label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='driver_name'
                        validate={!primaryDriver && validateEnglishOnly}
                        component={CustomInput}
                      />
                    </div>
                    {/* <div className='fe-form-field'>
                      <label htmlFor='driver_size'>
                        {t('form:tShirtSize')}
                      </label>
                      <Dropdown
                        name='driver_size'
                        value={values.driver_size}
                        customOnChange={false}
                        onChange={e =>
                          this.handleFieldChange(
                            e,
                            values,
                            'driver_size',
                            handleChange
                          )
                        }
                        options={sizes}
                      />
                    </div> */}
                    <div className='fe-form-field'>
                      <label htmlFor='driver_ic'>{t('form:icNo')}</label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='driver_ic'
                        validate={!primaryDriver && (e => validateIC(e, values, primaryDriver))}
                        component={CustomInput}
                      />
                    </div>
                    <div className='fe-form-field'>
                      <label htmlFor='driver_mobile'>
                        {t('form:mobileNo')}
                      </label>
                      <div className='fe-form-field-mobile'>
                        <div className='fe-form-mob-prefix'>+60</div>
                        <Field
                          onBlur={e =>
                            this.handleFieldBlur(e, values, handleBlur)
                          }
                          type='text'
                          name='driver_mobile'
                          validate={!primaryDriver && validateMobileNo}
                          component={CustomInput}
                          showError={false}
                          numbersOnly
                        />
                      </div>
                      <span className='fe-form-error'>
                        <ErrorMessage
                          name='driver_mobile'
                          render={msg => t(`error:${msg}`)}
                        />
                      </span>
                    </div>
                    <div className='fe-form-field'>
                      <label htmlFor='email'>{t('form:email')}</label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='email'
                        name='driver_email'
                        validate={!primaryDriver && (e => validateEmail(e, values, primaryDriver))}
                        component={CustomInput}
                      />
                    </div>
                    <div className={isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                      <label htmlFor='driver_experience'>{t('form:offRoadExperience')}</label>
                      <Dropdown
                        name='driver_experience'
                        value={values.driver_experience}
                        customOnChange={false}
                        onChange={e =>
                          this.handleFieldChange(
                            e,
                            values,
                            'driver_experience',
                            handleChange
                          )
                        }
                        options={difficultyName}
                      />
                    </div>
                    <div className={isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                      <label htmlFor='driver_size'>{t('form:tShirtSize')}</label>
                      <Dropdown
                        name='driver_size'
                        value={values.size}
                        customOnChange={false}
                        onChange={e =>
                          this.handleFieldChange(
                            e,
                            values,
                            'driver_size',
                            handleChange
                          )
                        }
                        options={sizes}
                      />
                      <label className='fe-form-field-description bottom'>
                        <span 
                          className='fe-clickable'
                          onClick={() => this.togglePopUpSize(true)}
                        >{t('form:sizeChart')}</span>
                      </label>
                      <label className='fe-form-field-description bottom'>
                        <span>{t('form:tshirtDescription')}</span>
                      </label>
                    </div>
                    <div className={isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                      <label htmlFor='driver_tshirtName'>{t('form:tshirtName')}</label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='driver_tshirtName'
                        validate={e => validateTshirtName(e, isRaptorEvent)}
                        component={CustomInput}
                      />
                    </div>
                    <div className={isRaptorEvent ? 'fe-form-field full' : 'fe-hide'}>
                      <label htmlFor='driver_health'>{t('form:healthDeclaration')}</label>
                      <label className='fe-form-field-description'>
                        <span>{t('form:healthDescription')}</span>
                        <br/><br/>
                        <span>{t('form:healthExample')}</span>
                      </label>
                      <Field
                        onBlur={e =>
                          this.handleFieldBlur(e, values, handleBlur)
                        }
                        type='text'
                        name='driver_health'
                        validate={e => validateHealth(e, values, 'driver_HealthConfirm', isRaptorEvent)}
                        placeholder={t('form:healthPlaceHolder')}
                        maxLength={0}
                        component={CustomTextArea}
                      />
                    </div>
                    <div className={isRaptorEvent ? 'fe-form-field full checkbox-description' : 'fe-hide'}>
                      <Field
                        name='driver_HealthConfirm'
                        message={t('form:healthCheckBox')}
                        validate={e => validateHealthCheckbox(e, values, 'driver_health', isRaptorEvent)}
                        component={CustomCheckbox}
                      />
                    </div>
                  </div>
                </fieldset>
                {[...Array(participants)].map((_, idx) => {
                  const nameStr = 'companionName' + idx;
                  const icStr = 'companionIc' + idx;
                  const emailStr = 'companionEmail' + idx;
                  const healthStr = 'companionHealth' + idx;
                  const healthConfirmStr = 'companionHealthConfirm' + idx;
                  const sizeStr = 'companionSize' + idx;
                  const tshirtNameStr = 'companionTshirtName' + idx;
                  // const num = (primaryDriver) ? idx+1 : idx;
                  const num = idx+1;

                  // const mobileStr = 'mobile' + idx;
                  return (
                    <fieldset key={idx}>
                      <legend className='fe-form-title'>
                        {t('gen:companion') + ' ' + num}
                      </legend>
                      <div className='fe-form-inner'>
                        <div className={'fe-form-field full'}>
                          <label htmlFor={nameStr}>
                            {t('form:fullNameAsIC')}
                          </label>
                          <Field
                            onBlur={handleBlur}
                            type='text'
                            name={nameStr}
                            validate={validateRequired}
                            component={CustomInput}
                          />
                        </div>
                        <div className='fe-form-field'>
                          <label htmlFor={icStr}>{t('form:icNo')}</label>
                          <Field
                            onBlur={handleBlur}
                            type='text'
                            name={icStr}
                            validate={e => validateIC(e, values, primaryDriver)}
                            component={CustomInput}
                          />
                        </div>
                        <div className='fe-form-field'>
                          <label htmlFor='email'>{t('form:email') + ' (Optional)'}</label>
                          <Field
                            onBlur={e =>
                              this.handleFieldBlur(e, values, handleBlur)
                            }
                            type='email'
                            name={emailStr}
                            validate={e => validateEmailNotRequired(e, values, primaryDriver)}
                            component={CustomInput}
                          />
                        </div>
                        <div className={isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                          <label htmlFor={sizeStr}>{t('form:tShirtSize')}</label>
                          <Dropdown
                            name={sizeStr}
                            value={values.size}
                            customOnChange={false}
                            onChange={e =>
                              this.handleFieldChange(
                                e,
                                values,
                                sizeStr,
                                handleChange
                              )
                            }
                            options={sizes}
                          />
                          <label className='fe-form-field-description bottom'>
                            <span 
                              className='fe-clickable'
                              onClick={() => this.togglePopUpSize(true)}
                            >{t('form:sizeChart')}</span>
                          </label>
                          <label className='fe-form-field-description bottom'>
                            <span>{t('form:tshirtDescription')}</span>
                          </label>
                        </div>
                        <div className={isRaptorEvent ? 'fe-form-field' : 'fe-hide'}>
                          <label htmlFor={tshirtNameStr}>{t('form:tshirtName')}</label>
                          <Field
                            onBlur={e =>
                              this.handleFieldBlur(e, values, handleBlur)
                            }
                            type='text'
                            name={tshirtNameStr}
                            validate={e => validateTshirtName(e, isRaptorEvent)}
                            component={CustomInput}
                          />
                        </div>
                        <div className={isRaptorEvent ? 'fe-form-field full' : 'fe-hide'}>
                          <label htmlFor={healthStr}>{t('form:healthDeclaration')}</label>
                          <label className='fe-form-field-description'>
                            <span>{t('form:healthDescription')}</span>
                            <br/><br/>
                            <span>{t('form:healthExample')}</span>
                          </label>
                          <Field
                            onBlur={e =>
                              this.handleFieldBlur(e, values, handleBlur)
                            }
                            type='text'
                            name={healthStr}
                            validate={e => validateHealth(e, values, healthConfirmStr, isRaptorEvent)}
                            placeholder={t('form:healthPlaceHolder')}
                            maxLength={0}
                            component={CustomTextArea}
                          />
                        </div>
                        <div className={isRaptorEvent ? 'fe-form-field full checkbox-description' : 'fe-hide'}>
                          <Field
                            name={healthConfirmStr}
                            message={t('form:healthCheckBox')}
                            validate={e => validateHealthCheckbox(e, values, healthStr, isRaptorEvent)}
                            component={CustomCheckbox}
                          />
                        </div>
                      </div>
                    </fieldset>
                  );
                })}
              </section>
              <section className='fe-form-tnc'>
                <fieldset>
                  <legend className='fe-form-title'>{t('form:tnc')}</legend>
                  <div className='fe-form-tnc-container'>
                    <div className="fe-scrollbar">
                      <div className="fe-tnc-main-div">
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">1.</div>
                          <div className="fe-tnc-text title">Acceptance of Terms and Conditions</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">1.1</div>
                          <div className="fe-tnc-text">The user (“<b>You</b>” or “<b>Your</b>”) of the Online Platform (as defined in Clause 2.4) [which is owned/provided by Sime Darby Auto ConneXion Sdn. Bhd. [Registration No.: 198101002488 (68602-V)] (“<b>SDAC</b>”, “<b>we</b>”, “<b>us</b>”, or “<b>our</b>”) is requested to read these terms and conditions (“<b>T&C</b>”) carefully before accessing the Online Platform to book and purchase the Experience(s) (as defined in Clause 2.2) available at the Online Platform with any of the Operators (as defined in Clause 2.6).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">1.2</div>
                          <div className="fe-tnc-text">These T&C constitute a valid and binding agreement between SDAC and You. By accessing, browsing or otherwise using the Online Platform, You warrant that You have fully read and understood these T&C and agree to be legally bound by these T&C and acknowledge unconditional acceptance without limitation or qualification of these T&C. The T&C and any amendments or modifications made thereto along with the general T&C of the Online Platform govern the use of the Online Platform for the purchase of the Experience(s).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">1.3</div>
                          <div className="fe-tnc-text">We may change these T&C at any time without any prior notice in writing to You by posting changes on the Online Platform. You shall review these T&C regularly to ensure that You are aware of any changes made by us. The continued use of the Online Platform by You after changes are posted means that You agree to be legally bound by these T&C as updated and/or amended. In the case of any violation of these T&C or any additional terms posted on the Online Platform, we reserve the right to seek all remedies available by law and in equity for such violations.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">1.4</div>
                          <div className="fe-tnc-text">In the case of ambiguities or discrepancies between or within any provision of these T&C, You shall inform SDAC immediately of such ambiguity or discrepancy and SDAC will endeavour to provide clarification as to the meaning of the said provision. Notwithstanding the aforesaid, SDAC shall decide as to the meaning and intent of any provision(s) in these T&C where the same may be thought to be obscure or in dispute. SDAC shall have the absolute right to correct any error or omission therein when correction is necessary to the proper fulfilment of the intent of these T&C. SDAC’s decision(s) thereon shall be final and binding.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">2.</div>
                          <div className="fe-tnc-text title">Definitions</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.1</div>
                          <div className="fe-tnc-text">“<b>Customer</b>” means any individual who is legally capable/competent to enter into a binding contract, whether for or by him/herself or for or on behalf of any individual / proprietorship / firm / partnership / limited liability partnership / company / corporation and interested in purchasing the Experience(s) online with the Operators through the Online Platform (“<b>Person</b>”) and includes (a) any Person who accesses the Online Platform; and (b) any Participant (as defined in Clause 2.7). If the Customer is accessing the Online Platform or making a purchase of the Experience(s) for or on behalf of any individual / proprietorship / firm / partnership / limited liability partnership / company / corporation, the Customer represents, warrants and undertakes that he/she is duly authorised to do so by the aforesaid individual / proprietorship / firm / partnership / limited liability partnership / company / corporation and shall produce proof of such authorisation to SDAC upon SDAC’s request.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.2</div>
                          <div className="fe-tnc-text">“<b>Experience(s)</b>” means any of the Ford Ranger Getaways Experience(s) that are marketed or sold by the Operators through the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.3</div>
                          <div className="fe-tnc-text">“<b>Experience Fee</b>” means the specified Experience(s)’ purchase amount (inclusive of the relevant tax amount and insurance premium amount) as displayed on the Online Platform at the time of the Customer’s purchase of the Experience(s). The Experience Fee is in Ringgit Malaysia (RM) and is final (shall not / cannot be varied).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.4</div>
                          <div className="fe-tnc-text">“<b>Online Platform</b>” means the Website which is owned/developed by SDAC that allows the Customer to book the purchase of Experience(s) online with the Operators. For the avoidance of doubt, SDAC owns all goodwill, proprietary and intellectual property rights (including without limitation to the trademark rights, copyright and design rights) arising from and relating to the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.5</div>
                          <div className="fe-tnc-text">“<b>Online Purchase</b>” means the purchase of the Experience(s) by the Customer with any of the Operators through the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.6</div>
                          <div className="fe-tnc-text">“<b>Operators</b>” means the third-party operators who are marketing or selling the Experience(s) in Malaysia through the Online Platform and organise, conduct and complete the Experience(s) purchased by the Customer.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.7</div>
                          <div className="fe-tnc-text">“<b>Participant</b>” means any Person for whom the purchase of the Experience(s) is made. For the avoidance of doubt, (a) a Participant may be a Customer; (b) the Participant(s) is/are required to bring along a Ford Ranger vehicle during the Experience(s); (c) the Participant(s) who will be driving a Ford Ranger vehicle during the Experience(s) is/are required to be adult(s) aged 18 and above and possess a valid driving license; (d) the non-driving Participant(s) may be adult(s) aged 18 and above (“<b>adult Participant</b>”) and/or children under the age of 18 (“<b>child Participant</b>”), provided always that any child Participant must be accompanied by an adult Participant at all times throughout the Experience(s); and (d) it is mandatory for the Customer to purchase insurance for each Participant via the Online Platform at the time of the Online Purchase; to enable each Participant to participate in the Experience(s).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">2.8</div>
                          <div className="fe-tnc-text">“<b>Website</b>” means the e-commerce enabled interactive internet world wide web site maintained by SDAC for the purpose of the Operators displaying, offering and administering the Experience(s) for booking and purchase by the Customer.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">3.</div>
                          <div className="fe-tnc-text title">Registration and Security</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">3.1</div>
                          <div className="fe-tnc-text">Opening of the SDAC Account</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-text">In the course of using the Online Platform, You may be required to open and maintain an account with the Online Platform (“<b>Account</b>”).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">3.2</div>
                          <div className="fe-tnc-text">Provision of Personal Information</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">3.2.1</div>
                            <div className="fe-tnc-text">As a condition to using some aspects of the Online Platform (including but not limited to the Account), You may be required to register with the Online Platform and select a password and user name (“<b>User ID</b>”).</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">3.2.2</div>
                            <div className="fe-tnc-text">You shall provide SDAC with accurate, complete and updated registration information. Failure to do so shall constitute a breach of this T&C, which may result in immediate termination of Your Account.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">3.2.3</div>
                            <div className="fe-tnc-text">You represent that You shall not (a) select or use as a SDAC User ID the name of another person with the intent to impersonate that person; or (b) use as a SDAC User ID a name subject to any rights of a person other than You without appropriate authorisation.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">3.2.4</div>
                            <div className="fe-tnc-text">SDAC reserves the right to refuse registration of or to cancel an Account at its sole discretion. You shall be responsible for maintaining the confidentiality of Your password.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">4.</div>
                          <div className="fe-tnc-text title">Online Purchase of Experience(s)</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.1</div>
                          <div className="fe-tnc-text">Subject to Clause 5, Customer can purchase more than one (1) Experience(s) through the Online Platform provided that the purchase process will be one (1) Experience(s) per Online Purchase.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.2</div>
                          <div className="fe-tnc-text">The Customer shall be solely responsible for providing accurate and pre-requisite information while making the Online Purchase of the Experience(s) on the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.3</div>
                          <div className="fe-tnc-text">In the event that the Customer purchase the Experience(s) for any Participant who is not the Customer (“<b>Third Party Purchase</b>”), the necessary details of each such Participant(s) are required to be inputted into the Online Platform at the time of the Online Purchase is made to enable each such Participant(s) to participate in the Experience(s). Each such Participant(s) shall indemnify and keep SDAC fully indemnified against all claims, losses, damages or costs that may be incurred or suffered by SDAC, its directors, employees, officers and representatives arising out of or in connection with the Third Party Purchase.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.4</div>
                          <div className="fe-tnc-text">Purchase Confirmation</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-text">Certain Experience(s) are stated on the Online Platform will be subject to instant confirmation i.e. the Customer shall receive the Confirmation E-Mail (as defined in Clause 4.5.1) upon completing the Online Purchase of such Experience(s) on the Online Platform. For Experience(s) which are not subject to instant confirmation on the Online Platform, the Customer shall only receive the Confirmation E-Mail within the required time for confirmation as stated on the Online Platform; which in any event shall not exceed three (3) working days.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.5</div>
                          <div className="fe-tnc-text">Purchase and Utilisation of the Experience(s)</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.5.1</div>
                            <div className="fe-tnc-text">Through the Online Platform, the Customers may purchase Experience(s) from the Operators in the various destinations. Subject to Clause 5.6, the Customer will receive an e-mail confirmation of the Customer’s Online Purchase that will contain a confirmation number (“<b>Confirmation E-Mail</b>”).</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.5.2</div>
                            <div className="fe-tnc-text">In order to utilise the Experience(s), the Participant(s) must appear in person at the meeting point designated by the relevant Operator on time, and present such documents and/or information as may be required by the Operator, that may include the Confirmation E-Mail. If the Participant(s) fail to appear on time or to provide the required documents or information (which may include the Confirmation E-Mail), request(s) for refund(s) of Experience Fee(s) will not be entertained.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.5.3</div>
                            <div className="fe-tnc-text">An Operator may also require the Participant(s) to provide an identification document bearing the Participant(s)’s photo in order to utilise the Experience(s). Neither SDAC nor the Operator is responsible for lost, destroyed or stolen Confirmation E-Mails. If You or the Participant(s) attempt to use a Confirmation E-Mail in an unlawful manner (e.g. the Participant(s) attempt to use an Confirmation E-Mail for the Experience(s) to drive on off-road terrain when the driving Participant(s) are under the legal age to drive or do not possess a valid driving license), the respective Operator may refuse to accept the Confirmation E-Mail, and no refunds of Experience Fee(s) will be entertained.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.6</div>
                          <div className="fe-tnc-text">Terms of the Confirmation E-Mail</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.6.1</div>
                            <div className="fe-tnc-text">The terms and conditions for each Experience(s) may vary amongst Operators and any restrictions that apply to the utilisation of such Experience(s), including but not limited to a minimum age requirement, will be conveyed to You at the time of the Online Purchase of the Experience(s) on the Online Platform.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.6.2</div>
                            <div className="fe-tnc-text">The Experience(s) may only be utilised on the date(s) which are stated on the Confirmation E-Mail. If the Participant(s) do not utilise the Experience(s) on or by the date(s) stated in such Confirmation E-Mail(s), except as expressly set forth therein, no refunds of the Experience Fee will be entertained.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.6.3</div>
                            <div className="fe-tnc-text">The Customer and the Participant(s) shall be bound by the terms and conditions of the Confirmation E-Mail applicable for the Experience(s) conducted by the Operators.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.7</div>
                          <div className="fe-tnc-text">Cancellation of Confirmation E-Mail</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.7.1</div>
                            <div className="fe-tnc-text">You may cancel the purchased Experience(s) mentioned in Your Confirmation E-Mail by sending an email to <a href="mailto:sdacford@simedarby.com">sdacford@simedarby.com</a> (“<b>Cancellation E-Mail</b>”) within the cancellation period of fifteen (15) working days prior to the date of the purchased Experience(s). SDAC and/or the Operator will initiate the refund of the Experience Fee to You after receipt of your Cancellation E-mail. If You cancel your Confirmation E-mail on any calendar date falling after the fifteenth (15th) working day, no refund of the Experience Fee will be permitted but You will be able to transfer the purchased Experience(s) to another/other Participants [“<b>Replacement Participant(s)</b>”]; subject to You have communicated the details of the Replacement Participants in your Cancellation E-Mail to SDAC.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.7.2</div>
                            <div className="fe-tnc-text">The Operator, not SDAC, is the offeror of the Experience(s) to which the Confirmation E-Mail(s) correspond to, and is solely responsible for accepting or rejecting any Experience(s) You purchase.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.7.3</div>
                            <div className="fe-tnc-text">Please directly consult with the Operator if You have any enquiries or complaints in respect of the Experience(s). Except as expressly set forth herein, the Experience Fees paid for the Experience(s) are non-refundable.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.7.4</div>
                            <div className="fe-tnc-text">If any Experience(s) which You have received a Confirmation E-Mail for is cancelled by the Operator, SDAC will notify You as soon as reasonably practicable, and the Agency (as defined in Clause 5.2) will process a full refund of the Experience Fee to the Internet Payment option You used to purchase the Experience(s).</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.8</div>
                          <div className="fe-tnc-text">Required Assistance</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-text">If You and/or the Participant(s) attempt to utilise the Experience(s) in accordance with this T&C and the additional terms and conditions applicable to such Experience(s) but You and/or the Participant(s) are unable to do so [due to the fault of the Operator e.g. ‘no-show’ of the Operator or an occurrence of event of Force Majeure (as defined in Clause 11.5) for the Experience(s) resulting in a need to re-schedule or cancel the Experience(s)], please contact SDAC at <a href="mailto:sdacford@simedarby.com">sdacford@simedarby.com</a>, and upon the occurrence of any of the aforesaid instance(s), the Operator may cause a refund of the Experience Fee paid to the Customer or at the Customer’s written option, the Customer [or the Participant(s) as the case may be] may choose an alternative date to enjoy/engage/participate in the Experience(s) purchased by the Customer.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">4.9</div>
                          <div className="fe-tnc-text">SDAC’s Rights and Obligations</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.9.1</div>
                            <div className="fe-tnc-text">SDAC reserves the right to deny and cancel the booking/purchase of any Experience(s) that are deemed in violation of this T&C. Such a determination is at SDAC’s sole discretion.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">4.9.2</div>
                            <div className="fe-tnc-text">Whilst the Operators are required to provide SDAC with accurate and updated Experience Fee of the Experience(s) on this Website, SDAC cannot guarantee that all Experience Fee for the Experience(s) provided by the Operators are accurate and updated at all times.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">5.</div>
                          <div className="fe-tnc-text title">Required Assistance</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">5.1</div>
                          <div className="fe-tnc-text">The Customer is required to pay the Experience Fee displayed on the Online Platform to the Operators at the time of the Online Purchase. Payment of the Experience Fee can be made via internet payment option(s) (including but not limited to online credit/debit card payments and/or other payment channels that emerge, relevant and applicable to online payments) in favour of the Operators (“<b>Internet Payment</b>”).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">5.2</div>
                          <div className="fe-tnc-text">Processing of the Internet Payment is undertaken by a third party payment gateway (“<b>Payment Processing Facility</b>”) facilitated by an intermediary agency which is appointed by SDAC (“<b>Agency</b>”).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">5.3</div>
                          <div className="fe-tnc-text">The Payment Processing Facility is arranged/provided only to facilitate the completion of the Internet Payment made by the Customer using the Payment Processing Facility for the purposes of debiting the Customer’s account for the Online Purchase in a smooth and swift manner (“<b>Transaction</b>”). Use of the Payment Processing Facility shall not render SDAC liable or responsible for the non-delivery, non-receipt, non-payment, damage, breach of representations and warranties, or fraud as regards to the Internet Payment and/or the Experience(s) listed on the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">5.4</div>
                          <div className="fe-tnc-text">The Customer hereby authorises the Agency to collect, process, facilitate and remit payments and/or the transaction electronically in respect of the Transaction through the Payment Processing Facility. The Customer understands, accepts and agrees that the Payment Processing Facility that is made available through the Agency is neither a banking nor financial service but is merely a facilitator providing automated online electronic payment, for the Transaction on the Online Platform using the existing authorised banking infrastructure and payment gateway networks. Notwithstanding the provision of the Payment Processing Facility, SDAC/Agency is neither acting as a trustee nor acting in a fiduciary capacity with respect to the Transaction undertaken by the Customer on the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point">5.5</div>
                          <div className="fe-tnc-text">The Customer agrees that SDAC shall not be held liable for any loss, damages, interests, claims, costs, expenses and/or any form/type of liability arising from:-</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">5.5.1</div>
                            <div className="fe-tnc-text">the Internet Payment and/or the Transaction undertaken by the Customer; and/or</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">5.5.2</div>
                            <div className="fe-tnc-text">the Payment Processing Facility operated by the Agency.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">5.6</div>
                          <div className="fe-tnc-text">Upon successful payment of the Experience Fee, the Customer will receive the Confirmation E-Mail in accordance to Clause 4.5.1.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">5.7</div>
                          <div className="fe-tnc-text">The Customer shall use the Confirmation E-Mail for all future communication with SDAC and/or the Operators by producing the copy of Confirmation E-Mail as and when required by SDAC and/or the Operators.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">6.</div>
                          <div className="fe-tnc-text title">Reviews – Further correspondence – Rights to User Content</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">6.1</div>
                          <div className="fe-tnc-text">By completing an Online Booking, You agree to receive the Confirmation E-Mail, as well as the invitation e-mail(s) for You to complete the review form which we will send to You after the Participant(s) complete the Experience(s) (“<b>Review E-mail</b>”). Leaving a review is optional. For clarity, the Confirmation E-Mail and Review E-mail are transactional and are not part of the newsletters or marketing mails, from which You can unsubscribe. The completed review may be uploaded onto the relevant Experience(s)’ page on the Online Platform for the sole purpose of informing (future) customers of Your / the Participant(s)’ opinion of the service (level) and quality of the Experience(s). Each Account may only submit one review per Experience(s) booked/purchased.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">6.2</div>
                          <div className="fe-tnc-text">By posting a review, You grant SDAC the full, perpetual, free, transferable and irrevocable rights to all submitted user content. SDAC reserves the right to translate, edit, adjust, refuse or remove reviews at its sole discretion.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">6.3</div>
                          <div className="fe-tnc-text">You represent and warrant that (a) You or the Participant(s) own and control all of the rights to the user content that You post or otherwise distribute, or You otherwise have the lawful right to post and distribute such user content to or through the Online Platform; (b) such content is accurate and not misleading; and (c) use and posting or other transmission of such content does not violate the T&C or any applicable laws and regulations and will not violate any rights of or cause injury to any person or entity.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">6.4</div>
                          <div className="fe-tnc-text">Reviews may not contain obscenities, profanity, inappropriate content, hate speech and offensive content, promotion of illegal conduct, other people’s personal information such as names, phone numbers or e-mail addresses, and irrelevant content such as promotion, invitation and reward information. Moreover, reviews may not defame, abuse, harass, or violate the legal rights of others.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">6.5</div>
                          <div className="fe-tnc-text">You further grant SDAC the right to pursue at law any person or entity that violates Your or SDAC’s rights in the content by a breach of the T&C. You agree You will be solely responsible for any user content You provide or submit.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">6.6</div>
                          <div className="fe-tnc-text">Content submitted by Customers will be considered non-confidential and SDAC is under no obligation to treat such content as confidential/proprietary information. Without limiting the foregoing, SDAC reserves the right to use the content as it deems appropriate, including, without limitation, deleting, editing, modifying, rejecting, or refusing to post it. SDAC is under no obligation to offer You any payment for content that You submit or the opportunity to edit, delete or otherwise modify content once it has been submitted to SDAC. SDAC shall have no duty to attribute authorship of content to You, and shall not be obligated to enforce any form of attribution by third parties.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">7.</div>
                          <div className="fe-tnc-text title">SDAC’s Liability for the Website and Content</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">7.1</div>
                          <div className="fe-tnc-text">SDAC cannot guarantee the authenticity and accuracy of any content, materials or information which the Operators may provide. All content, materials or information accessed by You using this Online Platform is at Your own risk and You will be solely responsible for any damage or loss to any party resulting therefrom.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">7.2</div>
                          <div className="fe-tnc-text">The Customer’s interactions with organisations and/or individuals found on or through the Experience(s) including but not limited to the Operators, including payment and delivery of goods or services, and any other terms, conditions, warranties or representations associated with such dealings, are solely between the Customer and the Operators and/or such organisations and/or individuals.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">7.3</div>
                          <div className="fe-tnc-text">The Customer should conduct whatever investigation You feel necessary or appropriate before proceeding with any online or offline transaction with any of these third parties.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">7.4</div>
                          <div className="fe-tnc-text">Under no circumstances will SDAC be liable in any way for any Content, including but not limited to any errors or omissions in any content, materials or information, or any loss or damage of any kind incurred in connection with the use of or exposure to any content, materials or information posted, e-mailed, accessed, transmitted, or otherwise made available via the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">8.</div>
                          <div className="fe-tnc-text title">Indemnity</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-text">You, the Customer(s) and/or the Participant(s) (as the case may be) will indemnify and hold SDAC, our holding companies, subsidiaries, affiliates, officers, directors and employees harmless from, including but not limited to all damages, liabilities, settlements, costs and attorney’s fees, claims or demands due to or arising out of:-</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">8.1</div>
                            <div className="fe-tnc-text">Your and/or the Customer’s (as the case may be) access to and use of the Online Platform, or Your and/or the Customer’s (as the case may be) violation of this T&C.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">8.2</div>
                            <div className="fe-tnc-text">any act or omission by/of You, the Customer(s) and/or the Participant(s) (as the case may be) whatsoever and howsoever relating to the Experience(s).</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">9.</div>
                          <div className="fe-tnc-text title">Disclaimers and Limitation of Liability</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">9.1</div>
                          <div className="fe-tnc-text">SDAC has no special relationship with and does not owe any fiduciary duty to You for accessing and using the Online Platform. SDAC makes no representations or warranties regarding the accuracy of descriptions anywhere on the Experiences offered or purchased through this Website.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">9.2</div>
                          <div className="fe-tnc-text">In no event will SDAC, this Website, or any of SDAC’s holding companies, subsidiaries, affiliates, officers, directors and/or employees be liable for any loss of profits, loss of opportunity or any direct, indirect, consequential, special, incidental, or punitive damages arising out of, based on, or resulting from: (a) the Online Platform; and/or (b) the T&C; and/or (c) any breach of the T&C by You or a third party; and/or (d) use of this Online Platform, the Internet Payment and/or the Payment Processing Facility by You or any third party.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">9.3</div>
                          <div className="fe-tnc-text">These limitations and exclusions apply without regard to whether the damages arise from (a) breach of contract; or (b) breach of warranty; or (c) strict liability; or (d) tort; or (e) negligence; or (f) any other cause of action, to the maximum extent that such exclusion and limitations are not prohibited by applicable law.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">9.4</div>
                          <div className="fe-tnc-text">The Online Platform, including all content, software, functions, materials and information made available on or accessed through the Online Platform, is provided on an “as is” basis. To the fullest extent permissible by applicable law, SDAC makes no representations or warranties of any kind, either express or implied, including but not limited to the content on the Online Platform or the materials, information and functions made accessible through the Online Platform, for any of the Experience(s) or for any breach of security associated with the transmission of sensitive information through the Online Platform, or for the Operators’ ability in relation to the operations of the Experience(s).</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">9.5</div>
                          <div className="fe-tnc-text">You acknowledge and agree that You will not hold or seek to hold SDAC responsible for the Experience(s) provided by the Operators or third party and You further acknowledge and agree that SDAC is not a party to any transaction in relation to the Experience(s) provided by any Operator or third party. SDAC has no control over and does not guarantee the safety of any Transaction, Experience(s) or the truth or accuracy of any listing or other content provided by any Operators on the Online.</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point">9.6</div>
                          <div className="fe-tnc-text">Remedies</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">9.6.1</div>
                            <div className="fe-tnc-text">If You are dissatisfied with the Online Platform, do not agree with any part of the T&C, or have any other dispute or claim with or against SDAC, Your sole and exclusive remedy against SDAC is to discontinue use of the Online Platform.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">9.6.2</div>
                            <div className="fe-tnc-text">In any event, to the fullest extent permissible by the applicable law, SDAC’s liability, and the liability of any member of SDAC, to You or any third party in any circumstance arising out of or in connection with the Online Platform and/or the Experience(s) is limited to the Experience Fee paid by You to the Operator.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">9.7</div>
                          <div className="fe-tnc-text">You agree that SDAC shall not be responsible or liable for any loss or damage of any sort incurred as the result of the Experience(s). If there is a dispute between You and the Operators, You understand and agree that SDAC is under no obligation to become involved in the dispute between You and the Operator(s). If You have a dispute with one or more Operators, you hereby release SDAC, its holding companies, subsidiaries, officers, directors, employees, agents, and successors in rights from claims, demands, and damages (actual and consequential) of every kind or nature, known or unknown, suspected or unsuspected, disclosed or undisclosed, arising out of or in any way related to such disputes.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">10.</div>
                          <div className="fe-tnc-text title">Termination</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">10.1</div>
                          <div className="fe-tnc-text">This T&C shall remain in full force and effect while You use the Online Platform or book/purchase/utilise the Experience(s). SDAC may terminate or suspend Your access to the Online Platform at any time, for any reason, and without notice, which may result in the forfeiture and destruction of all information associated with Your Account. SDAC may also terminate or suspend any and all access to the Platform immediately, without prior notice or liability, if You breach any of the terms or conditions of this T&C.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">10.2</div>
                          <div className="fe-tnc-text">Effects of Termination</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">10.2.1</div>
                            <div className="fe-tnc-text">Upon termination of Your Account, Your right to access the Online Platform will immediately cease. All provisions of this T&C which, by their nature, should survive termination, shall survive termination, including but not limited to ownership provisions, warranty disclaimers, and limitations of liability.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">10.2.2</div>
                            <div className="fe-tnc-text">If this T&C is terminated as a result of Your breach, SDAC reserves the right to cancel any outstanding Experience(s) You may have purchased prior to said termination, without refund or liability to You.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">11.</div>
                          <div className="fe-tnc-text title">General Terms</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.1</div>
                          <div className="fe-tnc-text">You, being the user of the Online Platform and/or the Customer, shall ensure full compliance of all applicable laws as amended from time to time.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.2</div>
                          <div className="fe-tnc-text">You/Customer shall be responsible for maintaining the confidentiality of information provided by You/Customer including but not limited to the mobile number, display name password, the Online Booking, the Internet Payment, the Transaction, the details of the Third Party Booking and all activities undertaken by You/Customer on/under the Online Platform. You are solely responsible to protect the password to Your Account on the Online Platform and SDAC will not be liable for any loss that You may incur as a result of someone using Your password or Account, either with or without Your knowledge. If You/Customer provide(s) any information that is untrue, inaccurate, not correct or incomplete or SDAC has reasonable grounds to suspect that such information is untrue, inaccurate, not correct or incomplete, SDAC shall have the right to indefinitely suspend or terminate or block access of You/Customer on the Online Platform and refuse to provide You/Customer with access to the Online Platform.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.3</div>
                          <div className="fe-tnc-text">The choice of Experience(s) would be updated on the Online Platform from time to time and shall be subject to availability by the Operators.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.4</div>
                          <div className="fe-tnc-text">SDAC shall not be held responsible for delay, loss or non-receipt of:-</div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">(a)</div>
                            <div className="fe-tnc-text">the Online Booking or its information inserted into any Online Booking; or</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">(b)</div>
                            <div className="fe-tnc-text">communication by You/Customer due to incorrect address or contact details/particulars given in the Online Platform; or</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row no-gap">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">(c)</div>
                            <div className="fe-tnc-text">the Internet Payment, the Payment Processing Facility, the Transaction and/or the Experience Fee; or</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">(d)</div>
                            <div className="fe-tnc-text">any other form of submission not contemplated herein.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.5</div>
                          <div className="fe-tnc-text">Delivery of the Experience(s) by the Operators is subject to “<b>Force Majeure</b>” conditions. The term “Force Majeure” means any circumstances beyond the control of SDAC concerned, the consequence of which could not have been avoided even if all due care had been exercised, including but not limited to acts of God, war or threat of war, riot, civil strike, hostilities, political unrest, government action or its related authority(ies), event(s) arising out of any enacted law, regulation etc., industrial dispute, natural or other disaster, epidemic, pandemic, nuclear incident, terrorist activity, sabotage, blockage, embargo, weather conditions, transport strike, fire, flood, typhoon, tempest, drought, short supply of labour, fuel, raw material, or manufactured produce, or otherwise preventing or hindering the delivery of the Experience(s) by the Operators and all similar events beyond the control of SDAC concerned.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.6</div>
                          <div className="fe-tnc-text">SDAC expressly disclaims any claim or liability arising out of the provision of this Online Platform. You/Customer agree(s) and acknowledge(s) that You/Customer shall be solely responsible for Your/Customer’s conduct and that SDAC expressly reserves the right to terminate Your/Customer’s rights to use the Online Platform at any time it deems fit. SDAC does not warrant the accuracy, adequacy or completeness of information and materials and expressly disclaims liability for errors or omissions in information and materials on the Online Platform. No warranty of any kind, implied, expressed or statutory including but not limited to the warranties of non-infringement of third party rights, merchantability and/or fitness for a particular purpose, is given. SDAC shall not be held responsible for any loss or damage howsoever caused by the software and related codes, including viruses and worms. SDAC does not warrant that the Online Platform and functions contained in the Online Platform will be uninterrupted. SDAC may suspend, withdraw, discontinue or change all or any part of the Online Platform without notice. SDAC shall not be held liable to You/Customer if for any reason the Online Platform or its content is unavailable at any time and/or for any period.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.7</div>
                          <div className="fe-tnc-text">The use of this Online Platform is entirely at Your/Customer’s own risk. In no event will SDAC and its directors, employees, officers and representatives be liable for any damages, including without limitation direct or indirect, special, incidental, punitive, exemplary or consequential damages, costs, losses, expenses, interests or any other type(s) and/or kinds(s) of claims arising in connection with or resulting from the Online Platform (including without limitation Your/Customer’s Online Booking through the Online Platform, Experience Fee, the Internet Payment, the Payment Processing Facility, and/or the Transaction) or any linked site or use thereof or inability to use by any party, or in connection with any failure of performance, error, omission, interruption, defect, delay in operation or transmission, computer virus or line or system failure and others even if SDAC or its authorised representative has been advised of the possibility of such damages. To the fullest extent as permitted by law, SDAC:-</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">11.7.1</div>
                            <div className="fe-tnc-text">excludes all representations and warranties relating to the Online Platform and its content or which is or may be provided by any other third party, including in relation to any inaccuracies or omissions in the Online Platform; and</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point"></div>
                          <div className="fe-tnc-row no-gap">
                            <div className="fe-tnc-point">11.7.2</div>
                            <div className="fe-tnc-text">excludes all liability for damages arising out of or in connection with the disclosure of the information and/or Your/Customer’s use of the Online Platform. This includes, without limitation, direct loss, loss of business or profits (whether or not the loss of such profits was foreseeable, arose in the normal course of things or You/Customer have/has advised SDAC of the possibility of such potential loss), damage caused to You/Customer in any manner whatsoever including but not limited to Your/Customer’s computer, computer software, systems and programs and the data thereon or any other direct or indirect, consequential and incidental damages.</div>
                          </div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.8</div>
                          <div className="fe-tnc-text">You/Customer shall fully indemnify and hold harmless SDAC, its affiliates, subsidiaries and their respective officers, directors, agents, employees and representatives, from any losses, claims, chargebacks or demand, or actions including reasonable legal fees, made by any third party including the Agency or penalty imposed due to or arising out of breach of these T&C, the Privacy Policy (as defined in Clause 12.5) and other policies of SDAC, Your/Customer’s use of the Online Platform or any of Your/Customer’s act or omission in violation of any law, rules or regulations or the rights (including infringement of intellectual property rights) by You/Customer.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">11.9</div>
                          <div className="fe-tnc-text">These T&C shall be governed by the laws of Malaysia and in case of any disputes involving SDAC, You/Customer consent(s) that Courts in Malaysia shall have exclusive jurisdiction.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point title">12.</div>
                          <div className="fe-tnc-text title">Personal Data Protection</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">12.1</div>
                          <div className="fe-tnc-text">You, being the user of the Online Platform and/or the Customer, shall ensure full compliance of the Personal Data Protection Act 2010 (Laws of Malaysia Act 709), as amended from time to time, (“<b>Data Protection Laws</b>”). You/Customer hereby expressly consent(s) to SDAC storing/transferring the personal data (personally identifiable data which defined under the Data Protection Laws) (“<b>Personal Data</b>”) that is voluntarily supplied herein and to process and use it by SDAC as it deems appropriate for the purposes of providing the Online Booking or share with its affiliates, associates, principal, agencies, auditors, legal advisers, marketing partners, representatives and others to contact You/Customer through outbound call by telephone/mobile numbers or send SMS or e-mail for offers, marketing and/or promotions, product related information, newsletter, market survey, poll, research, study, programs, enquiries about offerings, services and other legitimate purposes. SDAC may disclose information if required to do so by any government/regulatory agency/authority.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">12.2</div>
                          <div className="fe-tnc-text">All Personal Data accumulated will be acquired, processed and used according to the Data Protection Laws for the sole purpose of managing and maintaining SDAC’s own legitimate business interests.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">12.3</div>
                          <div className="fe-tnc-text">Although SDAC takes reasonable measures to safeguard against unauthorised disclosures of information, it cannot guarantee that the Personal Data is safe from unauthorised access/disclosure by hacking or otherwise.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">12.4</div>
                          <div className="fe-tnc-text">By accessing, browsing or otherwise using the Online Platform, You/Customer give(s) unconditional written consent to SDAC for being contacted for products/services of SDAC over telephone/mobile phone/e-mail/SMS.</div>
                        </div>
                        <div className="fe-tnc-row">
                          <div className="fe-tnc-point">12.5</div>
                          <div className="fe-tnc-text">Further, by impliedly or expressly accepting these T&C, You/Customer also give(s) unconditional acceptance to be bound by the privacy policy of SDAC (“<b>Privacy Policy</b>”), as amended from time to time. The Privacy Policy is available at <a href={`${process.env.APP_URL}/getaways/privacy-disclaimer`} rel="nofollow noopener noreferrer" target='_blank'>{`${process.env.APP_URL}/getaways/privacy-disclaimer`}</a>.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a
                    className='fe-u-btnlink alt'
                    href='/getaways/terms-and-conditions'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {t('form:readFullTnc')}
                  </a>
                  <div className='fe-form-checkboxes'>
                    <Field
                      name='agreeTnc'
                      message={t('form:checkboxTnc')}
                      validate={validateChecked}
                      component={CustomCheckbox}
                    />
                  </div>
                </fieldset>
              </section>
              <div className='fe-form-buttons no-margin'>
                <Button
                  type='submit'
                  onClick={() => {
                    this.setState({ resetError: false });
                    // Send click event to Google Tag Manager
                    TagManager.dataLayer({
                      dataLayer: {
                        event: 'click-next-step2'
                      }
                    });
                  }}
                >
                  {t('gen:next')}
                </Button>
                <Button onClick={() => setBookingStep(1)}>
                  {t('gen:goBack')}
                </Button>
                {/* {signedIn && !showNotification ? (
                  <Button className='borderless' onClick={this.saveForLater}>
                    {t('form:saveDetailsForLater')}
                  </Button>
                ) : null} */}
              </div>
              <span className='fe-form-error'>
                {Object.entries(errors).length > 0 && !resetError
                  ? t('error:incompleteForm')
                  : ''}
              </span>
            </form>
          )}
        </Formik>
      </div>
    );
  }
}

BookingDetails.propTypes = {
  bookingInfo: PropTypes.object.isRequired,
  savedInfo: PropTypes.object,
  bookingPax: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
    .isRequired,
  bookingFormData: PropTypes.object.isRequired,
  primaryDriver: PropTypes.bool.isRequired,
  companions: PropTypes.object.isRequired,
  companionStatus: PropTypes.object.isRequired,
  setBookingFormData: PropTypes.func.isRequired,
  setBookingPrimaryDriver: PropTypes.func.isRequired,
  setBookingStep: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  hide: PropTypes.bool.isRequired,
  slug: PropTypes.string.isRequired,
  fetchPricingInfo: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  signedIn: PropTypes.bool.isRequired,
  postSaveForLater: PropTypes.func.isRequired,
  handleSaveForLater: PropTypes.func.isRequired,
  promoCode: PropTypes.string.isRequired,
  saveMessage: PropTypes.string.isRequired
};

const mapStateToProps = ({ bookingState, authState, tripDetailsState }) => ({
  companions: bookingState.companionResponse,
  companionStatus: bookingState.companionStatus,
  bookingInfo: bookingState.bookingInfo,
  savedInfo: bookingState.savedInfo,
  bookingPax: bookingState.pax,
  isByPax: bookingState.bookingInfo.isByPax,
  bookingFormData: bookingState.formData,
  primaryDriver: bookingState.primaryDriver,
  loading: bookingState.loading,
  signedIn: authState.signedIn,
  saveMessage: bookingState.saveMessage,
  byorIsMember: bookingState.byorIsMember,
  tourDate: bookingState.tourDate,
  byorSelected: tripDetailsState.byorSelected,
  bookingDate: bookingState.date
});

const mapDispatchToProps = {
  setBookingFormData,
  setBookingPrimaryDriver,
  setBookingStep,
  fetchPricingInfo,
  postSaveForLater
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(BookingDetails)
);
